import store from './store';

export default store;



// WEBPACK FOOTER //
// ./src/app/cl-events/index.js